import {
  FETCH_DASHBOARD_DATA_START,
  FETCH_DASHBOARD_DATA_SUCCESS,
  FETCH_DASHBOARD_DATA_FAILURE,
  SET_LOAN_STATUS,
  SET_DOCUMENT_STATUS,
  SET_USER_DETAILS,
  SET_NOTIFICATIONS_READ,
  SET_CREDIT_MODEL,
  RESET_DASHBOARD,
} from "./types";

const initialState = {
  loading: true,
  error: null,
  loanStatus: {},
  documentStatus: {},
  userDetails: {},
  creditModel: {},
  credit: [],
  blocked: false,
  cibilFlow: "",
  canApplyForLoan: false,
  hasReadNotification: false,
  paydayAmount: 0,
  emiAmount: 0,
  precloserShow: false,
  hasLoanData: false,
};

const dashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DASHBOARD_DATA_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_DASHBOARD_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };

    case FETCH_DASHBOARD_DATA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case SET_LOAN_STATUS:
      return {
        ...state,
        loanStatus: action.payload.loanStatus,
        precloserShow: action.payload.precloserShow || false,
        hasLoanData: action.payload.hasLoanData || false,
      };

    case SET_DOCUMENT_STATUS:
      return {
        ...state,
        documentStatus: action.payload.documentStatus,
        blocked: action.payload.blocked || false,
        cibilFlow: action.payload.cibilFlow || "",
      };

    case SET_USER_DETAILS:
      return {
        ...state,
        userDetails: action.payload.userDetails,
        credit: action.payload.credit || [],
        creditModel: action.payload.creditModel || {},
        canApplyForLoan: action.payload.canApplyForLoan || false,
        paydayAmount: action.payload.paydayAmount || 0,
        emiAmount: action.payload.emiAmount || 0,
      };

    case SET_NOTIFICATIONS_READ:
      return {
        ...state,
        hasReadNotification: action.payload,
      };

    case SET_CREDIT_MODEL:
      return {
        ...state,
        creditModel: action.payload,
      };

    case RESET_DASHBOARD:
      return initialState;

    default:
      return state;
  }
};

export default dashboardReducer;
